
import { legacyApi } from '@dashboardApp/store';
import { useUserStore } from '@dashboardApp/stores/UserStore';

const userStore = useUserStore();

const saveMeta = (key, value = 1, immediateValueAssignment = false) => {
    const meta = getMeta(key);
    if (meta && meta == value) {
        return;
    }

    if (immediateValueAssignment) {
        userStore.user.meta[key] = value;
    }

    return legacyApi.post('/members/save_meta', {
        data: {
            MemberMeta: {
                meta_key: key,
                meta_value: value
            }
        }
    }).then((data) => {
        if (!immediateValueAssignment) {
            userStore.user.meta[key] = value;
        }
        userStore.bumpSession();
        return data;
    }).catch(() => {
        userStore.user.meta[key] = null;
    });
};

const getMeta = (key) => {
    if (typeof userStore.user?.meta === 'object'  && Object.hasOwn(userStore.user?.meta, key)) {
        return userStore.user.meta[key];
    }
    return null;
}

const hasMeta = (key) => getMeta(key) !== null;

export default function useMemberMeta () {
    return {
        saveMeta, getMeta, hasMeta
    }
}